import { useAtomValue } from 'jotai';

import type { OrdersFacets, OrdersTableRow,PaginatedResponse } from '@ekhodealer/ekho-common';

import { useSearchOrders } from '../api/useSearchOrders';
import { ordersBaseParamsAtom } from '../atoms/ordersAtoms';

/**
 * Hook to get facet counts for filter options
 * Returns counts for payment choice, payment status, and financing status filters
 * Uses base params (without payment/financing filters) to show total available options
 *
 * Facets are now transformed in the backend and returned in a UI-friendly structure
 */
export function useFilterFacetCounts() {
	const baseParams = useAtomValue(ordersBaseParamsAtom);
	const { data } = useSearchOrders(baseParams);

	// Use transformed facets from the response
	const response = data as PaginatedResponse<OrdersTableRow> | undefined;
	const facets = response?.facets as OrdersFacets | undefined;

	return {
		paymentChoiceCounts: facets?.paymentChoice || { financing: 0, 'full-cash': 0 },
		paymentStatusCounts: facets?.paymentStatus || {},
		financingStatusCounts: facets?.financingStatus || {},
		modelCounts: facets?.models || {},
		typeCounts: facets?.vehicleTypes || {},
		registrationStateCounts: facets?.registrationStates || {},
		deliveryCount: facets?.fulfillmentTypes?.delivery,
		pickupCount: facets?.fulfillmentTypes?.pickup,
	};
}
